import React from "react";

import { BookingTypes } from "../../BookingsSearch/BookingsSearch";
import { CreatablePeopleList } from "./CreatablePeopleList";
import { SelectPeopleList } from "./SelectPeopleList";
import { BookOnBehalf } from "../BookOnBehalf/BookOnBehalf";

interface Props {
  type: BookingTypes;
  showBookOnBehalf?: boolean;
  hideFindPeople?: boolean;
}

const WorkplaceComponent: {
  [key in BookingTypes]: React.FunctionComponent<any>;
} = {
  room: CreatablePeopleList,
  desk: SelectPeopleList,
};

export const FindPeopleButton = ({
  type,
  showBookOnBehalf,
  hideFindPeople,
}: Props) => {
  const Component = WorkplaceComponent[type];

  return (
    <>
      {!hideFindPeople && <Component />}
      {showBookOnBehalf && <BookOnBehalf />}
    </>
  );
};
